<template>
  <v-layout>
    <v-flex xs12>
      <input type="file" style="display :none" ref="videofileInput" @change="onVideoFilePicked">
      <v-btn color="primary" class="uploadbtn" dark @click="videofileUploadInit">
        <v-icon left>file_upload</v-icon>
        {{ title }}
      </v-btn>
    </v-flex>
  </v-layout>
</template>
<script>
import { onVideoFilePicked, videofileUploadInit } from "@/common/methods.js";

export default {
  name: "VideoUpload",
  props: {
    title: {
      type: String,
      default: "Upload"
    }
  },
  computed: {},
  data() {
    return {
      image: null,
      imageUrl: "",
      formData: null,
      rawImage: null,
      standAlone: true,
      fileName: "",
      fileSize: ""
    };
  },
  methods: {
    onVideoFilePicked,
    videofileUploadInit,
    emitData() {
      const image = this.image;
      const imageUrl = this.imageUrl;
      const rawImage = this.rawImage;
      const fileName = this.fileName;
      const fileSize = this.fileSize;
      this.$emit("image", { image, imageUrl, rawImage, fileSize });
      this.$emit("file", { image, fileName, rawImage });
    },
    emitSize() {
      const fileSize = this.fileSize;
      const image = this.image;
      const imageUrl = "";
      const rawImage = null;
      this.$emit("image", { image, imageUrl, rawImage, fileSize });
    }
  }
};
</script>

<style scoped>
.uploadbtn {
  text-transform: capitalize;
}
</style>
